import moment from 'moment'
import React, { useContext } from 'react'
import { useDispatch} from 'react-redux'
import { Popup, Button, Icon } from "semantic-ui-react";
import { importNewModal } from '../../redux/actions/newModal'
import { RefetchBankDataById } from "src/graphql/bankAccounts";
import './lastBankUpdate.scss'
import { importAlertState } from 'src/redux/actions/alert';
import { CompanyContext, UserContext } from "src/context";
import { Roles } from 'src/utils/roles';
import { SCFO_EXCEPTIONS } from 'src/utils/scfo_exceptions';

export default function LastBankUpdate({bank, bankName, noPadding}) {
    const dispatch = useDispatch()
    const { reexecuteQuery } = RefetchBankDataById()
    const { roles } = useContext(UserContext)
    const { selectedCompany } = useContext(CompanyContext)

    const isSCFO = false

    const openModal = () => {
        dispatch(
            importNewModal({
                show: true,
                title: `Actualizar ${bankName}`,
                content: isSCFO ? 'Su usuario no tiene acceso a refrescar el banco' : `¿Está seguro que desea actualizar su ${bankName}?`,
                subcontent: isSCFO ? 'Por favor, contacte a su tesorero para gestionar su cuenta' : `Tomará unos minutos obtener su información actualizada.` ,
                subsubcontent: isSCFO ? null : `Se le notificará cuándo termine la actualización del banco.`,
                hideAcceptButton: isSCFO === true,
                onConfirm: () => {
                    reexecuteQuery({ id: bank.passwordId })     
                    dispatch(
                        importAlertState({
                            concept: 'Actualizando información bancaria.',
                            content: "Te notificaremos cuando hayamos terminado. Esto puede tomar unos minutos.",
                            state: "loading",
                            duration: 8,
                        })
                    )           
                    dispatch(importNewModal({ show: false }))
                },
          }))
    }

    return (
        <Popup
        size='small'
            content={`Hora Últ. Actualización: ${bank?.createdAt ? moment(bank?.createdAt).format('DD/MM/YYYY HH:mm') : 'No hay información' }`}
            trigger={<Button
                        onClick={openModal}
                        className={`ml-2 lastBankUpdateButton ${noPadding ? 'p-0' : ''}`}
                        animated
                        size='mini'
                        type='button'
                        circular
                        >
                            <Button.Content visible>
                                <Icon name='clock outline' color='grey' size='large' />
                            </Button.Content>
                            <Button.Content hidden>
                                <Icon name="sync alternate" color='grey' size='large' />
                            </Button.Content>
                    </Button>
                }
        />
    )
}